<template>
    <div style="padding-top: 20px;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="上级科室：" prop="parentId">
                <div class="form_item_box">
                    <el-cascader filterable v-model="ruleForm.parentId" :options="branchList" :props="cascaderKey"
                        clearable></el-cascader>
                </div>
            </el-form-item>
            <el-form-item label="科室名称：" prop="deskName">
                <div class="form_item_box">
                    <el-input v-model="ruleForm.deskName" placeholder="请输入科室名称" clearable></el-input>
                </div>
            </el-form-item>
            <el-form-item label="科室电话：" prop="phone">
                <div class="form_item_box">
                    <el-input v-model="ruleForm.phone" placeholder="请输入科室电话" clearable></el-input>
                </div>
            </el-form-item>
            <el-form-item label="楼宇：" prop="building">
                <div class="form_item_box">
                    <el-select v-model="ruleForm.building" placeholder="请选择" @change="selectBuilding" clearable>
                        <el-option v-for="item in buildingList" :key="item.id" :label="item.buildingName" v-model="item.id">
                        </el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="楼层：" prop="floor">
                <div class="form_item_box">
                    <el-select v-model="ruleForm.floor" placeholder="请选择" clearable>
                        <el-option v-for="item in floorList" :key="item.id" :label="item.floorName" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </el-form-item>
          <el-form-item label="重点科室：" prop="isImportant">
            <div class="form_item_box">
              <el-select v-model="ruleForm.isImportant" placeholder="请选择" clearable>
                <el-option label="否" :value="2">
                </el-option>
                <el-option label="是" :value="1">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
            <el-form-item>
                <div style="width: 100%; margin-left: -50px; display: flex; justify-content: center;">
                    <el-button type="primary" @click="submitForm('ruleForm')" style="width: 100px;">确定</el-button>
                    <el-button @click="resetForm()" style="width: 100px;">取消</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: ["branchModal", "command"],
    data() {
        return {
            ruleForm: {
                parentId: '',
                deskName: '',
                phone: '',
                building: '',
                floor: "",
              isImportant:2,
            },
            buildingList: [],
            branchList: [],
            floorList: [],
            cascaderKey: {
                value: "id",
                label: "deskName",
                checkStrictly: true,
                emitPath: false
            },
            rules: {
                deskName: [
                    { required: true, message: '请输入科室名称', trigger: 'blur' },
                ],
            }
        }
    },
    mounted() {
        this.getBranch()
        this.getBuilding()
        if (this.command) {
            if (this.command.type == "add") {
                this.ruleForm.parentId = this.command.node.data.id
            } else if (this.command.type == "edit") {
                let node = this.command.node.data
                if (node.parentId != 0) {
                    this.ruleForm.parentId = node.parentId
                }
                this.ruleForm.deskName = node.deskName
                this.ruleForm.phone = node.phone
              this.ruleForm.isImportant = node.isImportant
                if (node.building) {
                    this.ruleForm.building = parseInt(node.building)
                    this.getFloor(this.ruleForm.building)
                    if (node.floor) {
                        this.ruleForm.floor = parseInt(node.floor)
                    }
                }

            }
        }
        // this.getFloor()
    },
    methods: {
        async getBranch() {
            let d = {
            }
            let res = await $utils.api.load("admin/system/desk/list", d, "get")
            if (res.code == 200) {
                this.branchList = res.rows
            }
            // console.log(res);
        },
        async getBuilding() {
            let d = {}
            let res = await $utils.api.load('admin/system/building/list', d, "get")
            // console.log(res);
            if (res.code == 200) {
                this.buildingList = res.rows
            }
        },
        async getFloor(e) {
            let d = {
                buildingId: e
            }
            let res = await $utils.api.load("admin/system/floor/list", d, "get")
            // console.log(res);
            if (res.code == 200) {
                this.floorList = res.rows
            }
        },
        selectBuilding(e) {
            this.getFloor(e)
        },
        submitForm(formName) {
            let that = this
            let types = ""
            if (that.command) {
                types = that.command.type
                if (that.command.type == "edit") {
                    that.ruleForm.id = that.command.node.data.id
                }
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (that.ruleForm.parentId) {
                        that.ruleForm.isParent = 1
                    } else {
                        that.ruleForm.isParent = 0
                    }
                    $utils.api.load("/admin/system/desk", that.ruleForm, `${types == "edit" ? "PUT" : "post"}`).then(res => {
                        if (res.code == 200) {
                            $utils.toast.success(types == "edit" ? "修改成功" : "新增成功");
                            that.resetForm()
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        resetForm() {
            this.$emit("branchModal")
        }
    }
}
</script>

<style lang="less" scoped>
.form_item_box {
    width: 100%;
}

.el-cascader,
.el-select {
    width: 100%;
}

.el-button+.el-button {
    margin-left: 40px;
}
</style>